// utils/renewalUtils.js
export const getNextRenewalDate = (dateOfEstablishment) => {
  const establishmentDate = new Date(dateOfEstablishment);
  const currentDate = new Date();

  let nextRenewalDate = new Date(establishmentDate);
  nextRenewalDate.setFullYear(currentDate.getFullYear());

  if (currentDate > nextRenewalDate) {
    nextRenewalDate.setFullYear(currentDate.getFullYear() + 1);
  }

  return nextRenewalDate;
};

export const isRenewalDue = (nextRenewalDate) => {
  const currentDate = new Date();
  return currentDate >= nextRenewalDate;
};
